/* MT home only — deferred and browser-cacheable. */
(function () {
      'use strict';

      const root = document.getElementById('mt-home-2026');
      if (!root) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      root.dataset.ready = 'true';

      const rail = root.querySelector('[data-best-rail]');
      const nav = root.querySelector('[data-best-nav]');
      if (rail && nav) {
        const cards = Array.from(rail.children);
        const previous = nav.querySelector('[data-best-step="-1"]');
        const next = nav.querySelector('[data-best-step="1"]');
        const count = nav.querySelector('[data-best-count]');
        let frame = 0;

        function positions() {
          const origin = cards[0].offsetLeft;
          const end = Math.max(0, rail.scrollWidth - rail.clientWidth);
          return cards.map(card => Math.min(end, Math.max(0, card.offsetLeft - origin)));
        }

        function syncRail() {
          frame = 0;
          const end = Math.max(0, rail.scrollWidth - rail.clientWidth);
          const offsets = positions();
          const index = offsets.reduce((best, pos, i) =>
            Math.abs(pos - rail.scrollLeft) < Math.abs(offsets[best] - rail.scrollLeft) ? i : best, 0);
          const padding = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
          const origin = cards[0].offsetLeft;
          const visible = cards.map((card, i) => ({
            index:i,
            left:card.offsetLeft - origin + padding,
            width:card.offsetWidth
          })).filter(card =>
            card.left >= rail.scrollLeft - 3 &&
            card.left + card.width <= rail.scrollLeft + rail.clientWidth - padding + 3);
          previous.disabled = rail.scrollLeft <= 3;
          next.disabled = rail.scrollLeft >= end - 3;
          nav.hidden = end <= 3;
          count.textContent = (visible.length > 1
            ? (visible[0].index + 1) + '–' + (visible[visible.length - 1].index + 1)
            : ((visible.length ? visible[0].index : index) + 1)) + ' / ' + cards.length;
        }

        function scheduleRail() {
          if (!frame) frame = requestAnimationFrame(syncRail);
        }

        nav.addEventListener('click', function (event) {
          const button = event.target.closest('[data-best-step]');
          if (!button || button.disabled) return;
          const forward = button.dataset.bestStep === '1';
          const offsets = [...new Set(positions())];
          const target = forward
            ? offsets.find(offset => offset > rail.scrollLeft + 3)
            : offsets.reverse().find(offset => offset < rail.scrollLeft - 3);
          if (target !== undefined) {
            rail.scrollTo({left:target, behavior:reducedMotion.matches ? 'auto' : 'smooth'});
          }
        });
        rail.addEventListener('scroll', scheduleRail, {passive:true});
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(function () {
            if (!root.isConnected) { observer.disconnect(); return; }
            scheduleRail();
          });
          observer.observe(rail);
        } else {
          window.addEventListener('resize', scheduleRail, {passive:true});
        }
        requestAnimationFrame(syncRail);
      }
    }());
